import { Sprite } from "pixi.js";
import Layers from "slotworks/graphics/layers/layers";
import * as TweenJS from "slotworks/utils/tween";
import settingsModel from "slotworks/model/settings/settings-model";
import g288SettingsModel from "model/g288-settings-model";

export default class StackArrowsComponent {

    private leftArrows: Sprite[];
    private rightArrows: Sprite[];

    private tweens: TweenJS.Tween[] = [];

    public init() {
        this.leftArrows = [];
        this.leftArrows.push(Layers.Custom.get("Animations").getSprite("stackarrow1"));
        this.leftArrows.push(Layers.Custom.get("Animations").getSprite("stackarrow2"));
        this.rightArrows = [];
        this.rightArrows.push(Layers.Custom.get("Animations").getSprite("stackarrow1r"));
        this.rightArrows.push(Layers.Custom.get("Animations").getSprite("stackarrow2r"));
        this.anchor(this.rightArrows[0]);
        this.anchor(this.rightArrows[1]);
        this.rightArrows[0].visible = false;
        this.rightArrows[1].visible = false;
    }

    public start() {
        const left = Layers.Custom.get("Animations").getPosition("stackarrow1");
        const right = Layers.Custom.get("Animations").getPosition("stackarrow1r");
        // const quickspin = g288SettingsModel.needQuickerSpin() ? true : settingsModel.getQuickSpin();
        // const delay = quickspin ? 600 : 1100; // uk 600
        const quickspin = settingsModel.getQuickSpin();
        const delay =  quickspin ? 200 : g288SettingsModel.needQuickerSpin() ? 600 : 1100;
        const time = quickspin ? 100 : 200;
        this.showRightArrow(time, delay);
        const obj = { x: 0 }
        const update = () => {
            this.leftArrows[0].x = this.leftArrows[1].x = left.x - obj.x;
            this.rightArrows[0].x = this.rightArrows[1].x = right.x + right.width + obj.x;
        }
        this.tweens.push(
            new TweenJS.Tween(obj)
            .to({x: 15 }, 250)
            .delay(delay)
            .onUpdate(update)
            .onComplete(() => {
                this.tweens.push(
                    new TweenJS.Tween(obj)
                    .to({x: -6 }, 150)
                    .delay(100)
                    .onUpdate(update)
                    .onComplete(() => {
                        new TweenJS.Tween(obj)
                        .to({x: 0 }, 100)
                        .onUpdate(update)
                        .start();
                    })
                    .start());
            })
            .start()
        )
    }

    public skip() {
        this.end();
        const left = Layers.Custom.get("Animations").getPosition("stackarrow1");
        const right = Layers.Custom.get("Animations").getPosition("stackarrow1r");
        this.rightArrows[0].visible = true;
        this.rightArrows[1].visible = true;
        this.rightArrows[0].scale.set(1, 1);
        this.rightArrows[1].scale.set(1, 1);
        this.leftArrows[0].x = this.leftArrows[1].x = left.x;
        this.rightArrows[0].x = this.rightArrows[1].x = right.x + right.width;
    }

    public end() {
        for(const tween of this.tweens) {
            tween.stop();
            TweenJS.remove(tween);
        }
        this.tweens.length = 0;
    }

    public hideRightArrows(instant: boolean = false) {
        if(this.rightArrows[0].visible)
        if(instant) {
            this.rightArrows[0].visible = false;
            this.rightArrows[1].visible = false;
        } else {
            new TweenJS.Tween(this.rightArrows[0].scale)
            .to({x: 0, y: 0}, 100)
            .start();
            new TweenJS.Tween(this.rightArrows[1].scale)
            .to({x: 0, y: 0}, 100)
            .onComplete(() => {
                this.rightArrows[0].visible = false;
                this.rightArrows[1].visible = false;
            })
            .start();
        }
    }

    private showRightArrow(time: number, delay: number = 0) {
        this.rightArrows[0].visible = true;
        this.rightArrows[1].visible = true;
        this.rightArrows[0].scale.set(0, 0);
        this.rightArrows[1].scale.set(0, 0);
        this.tweens.push(
        new TweenJS.Tween(this.rightArrows[0].scale)
        .to({x: 1, y: 1}, time)
        .delay(delay)
        .start());
        this.tweens.push(
        new TweenJS.Tween(this.rightArrows[1].scale)
        .to({x: 1, y: 1}, time)
        .delay(delay)
        .start());
    }

    private anchor(el: PIXI.Sprite) {
        el.anchor.set(0.98, 0.5);
        el.x += el.width;
        el.y += el.height * 0.5;
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/stack-feature/stack-arrows-component.ts